// import React, { useState } from "react";
// import axios from "axios";
// import { formatPhoneNumber } from "../utils/formatPhoneNumber";
// import { CONTACT_BASE_URL } from "../services/contactService";
// import "./ContactStyle.css";

// const ContactMe = () => {
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     phone: "",
//     subject: "",
//     email: "",
//     description: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     if (errors[name]) {
//       setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
//     }
//   };

//   //hide email

//   const [showFullEmail, setShowFullEmail] = useState(false);
//   const fullEmail = "osman.techy@gmail.com";
//   const maskedEmail = "(osman)***@gmail.com";

//   const handleClick = () => {
//     setShowFullEmail(!showFullEmail);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setErrors({});
//     setIsSubmitted(false);

//     // Validate required fields
//     const { firstName, lastName, email, description } = formData;
//     const newErrors = {};

//     if (!firstName) newErrors.firstName = "First name is required.";
//     if (!lastName) newErrors.lastName = "Last name is required.";
//     if (!email) newErrors.email = "Email address is required.";
//     if (!description) newErrors.description = "Message body is required.";

//     if (Object.keys(newErrors).length > 0) {
//       setErrors({
//         message: "Please fill in all required fields!",
//         ...newErrors,
//       });
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${CONTACT_BASE_URL}/api/contacts/create`,
//         formData
//       );
//       if (response.status === 200 || response.status === 201) {
//         setIsSubmitted(true);
//         setFormData({
//           firstName: "",
//           lastName: "",
//           phone: "",
//           subject: "",
//           email: "",
//           description: "",
//         });
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       if (error.response) {
//         const { message, errors: backendErrors } = error.response.data;
//         if (backendErrors && Array.isArray(backendErrors)) {
//           const formattedErrors = backendErrors.reduce((acc, err) => {
//             acc[err.param] = err.msg;
//             return acc;
//           }, {});
//           setErrors({
//             message: message || "Validation errors occurred",
//             ...formattedErrors,
//           });
//         } else if (message) {
//           setErrors({ message });
//         }
//       } else if (error.request) {
//         setErrors({
//           message: "No response from server. Please try again later.",
//         });
//       } else {
//         setErrors({
//           message: "An unexpected error occurred. Please try again.",
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container my-5">
//       <div className="row g-4">
//         {/* Contact Info Section */}
//         <div className="col-lg-5">
//           <div className="card h-100 border-0 shadow-sm">
//             <div className="card-body p-4 p-md-5 bg-primary text-white rounded-start">
//               <h1 className="card-titlexx mb-4 text-white">Get in Touch</h1>
//               <p className="card-text mb-4">
//                 Have a project in mind or want to discuss potential
//                 opportunities? Fill out the form and I'll get back to you as
//                 soon as possible.
//               </p>

//               <div className="mb-4">
//                 <div className="d-flex align-items-center mb-3">
//                   <i className="fa fa-envelope fa-lg me-3"></i>
//                   <a
//                     href="mailto:osman.techy@gmail.com"
//                     onClick={handleClick}
//                     className="text-white"
//                   >
//                     {showFullEmail ? fullEmail : maskedEmail}
//                   </a>
//                 </div>
//               </div>

//               <div>
//                 <h5 className="mb-3">Connect with me</h5>
//                 <div className="d-flex gap-3">
//                   <a
//                     href="https://www.facebook.com/moudeyahmad"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-white"
//                   >
//                     <i className="fa fa-facebook-f fa-lg"></i>
//                   </a>
//                   <a
//                     href="https://www.linkedin.com/in/mahmoudaosman/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-white"
//                   >
//                     <i className="fa fa-linkedin-in fa-lg"></i>
//                   </a>
//                   <a
//                     href="https://github.com/mahmoudahmadosman"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-white"
//                   >
//                     <i className="fa fa-github fa-lg"></i>
//                   </a>
//                   <a
//                     href="https://twitter.com/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-white"
//                   >
//                     <i className="fa fa-twitter fa-lg"></i>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Contact Form Section */}
//         <div className="col-lg-7">
//           <div className="card h-100 border-0 shadow-sm">
//             <div className="card-body p-4 p-md-5">
//               {isSubmitted ? (
//                 <div className="text-center py-4">
//                   <div className="mb-4">
//                     <div className="d-inline-flex bg-success bg-opacity-10 p-4 rounded-circle">
//                       <i className="fa fa-check-circle text-success fa-4x"></i>
//                     </div>
//                   </div>
//                   <h3 className="mb-3">Thank You!</h3>
//                   <p className="mb-4">
//                     Your message has been sent successfully. I'll get back to
//                     you soon.
//                   </p>
//                   <button
//                     className="btn btn-outline-primary"
//                     onClick={() => setIsSubmitted(false)}
//                   >
//                     Send Another Message
//                   </button>
//                 </div>
//               ) : (
//                 <>
//                   <h2 className="mb-4">Send a Message</h2>
//                   {errors.message && (
//                     <div className="alert alert-danger d-flex align-items-center mb-4">
//                       <i className="fa fa-exclamation-circle me-2"></i>
//                       <div>{errors.message}</div>
//                     </div>
//                   )}

//                   <form onSubmit={handleSubmit}>
//                     <div className="row g-3 mb-3">
//                       <div className="col-md-6">
//                         <label htmlFor="firstName" className="form-label">
//                           <i class="fa fa-user me-2 text-primary"></i>
//                           First Name <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control form-control-lg ${
//                             errors.firstName ? "is-invalid" : ""
//                           }`}
//                           id="firstName"
//                           name="firstName"
//                           value={formData.firstName}
//                           onChange={handleChange}
//                           placeholder="First name"
//                         />
//                         {errors.firstName && (
//                           <div className="invalid-feedback">
//                             {errors.firstName}
//                           </div>
//                         )}
//                       </div>

//                       <div className="col-md-6">
//                         <label htmlFor="lastName" className="form-label">
//                           <i class="fa fa-user me-2 text-primary"></i>
//                           Last Name <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control form-control-lg ${
//                             errors.lastName ? "is-invalid" : ""
//                           }`}
//                           id="lastName"
//                           name="lastName"
//                           value={formData.lastName}
//                           onChange={handleChange}
//                           placeholder="Last name"
//                         />
//                         {errors.lastName && (
//                           <div className="invalid-feedback">
//                             {errors.lastName}
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     <div className="mb-3">
//                       <label htmlFor="email" className="form-label">
//                         <i class="fa fa-envelope me-2 text-primary"></i>
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="email"
//                         className={`form-control form-control-lg ${
//                           errors.email ? "is-invalid" : ""
//                         }`}
//                         id="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         placeholder="your.email@gmail.com"
//                       />
//                       {errors.email && (
//                         <div className="invalid-feedback">{errors.email}</div>
//                       )}
//                     </div>

//                     <div className="mb-3">
//                       <label htmlFor="phone" className="form-label">
//                         <i class="fa fa-phone me-2 text-primary"></i>
//                         Phone Number
//                       </label>
//                       <input
//                         type="tel"
//                         className={`form-control form-control-lg ${
//                           errors.phone ? "is-invalid" : ""
//                         }`}
//                         id="phone"
//                         name="phone"
//                         value={formatPhoneNumber(formData.phone)}
//                         onChange={handleChange}
//                         placeholder="(123) 456-7890"
//                         maxLength={14}
//                       />
//                       {errors.phone && (
//                         <div className="invalid-feedback">{errors.phone}</div>
//                       )}
//                     </div>

//                     <div className="mb-3">
//                       <label htmlFor="subject" className="form-label">
//                         <i className="fa fa-tag form-icon me-2"></i>Subject
//                       </label>
//                       <select
//                         className={`form-select form-control-lg ${
//                           errors.subject ? "is-invalid" : ""
//                         }`}
//                         id="subject"
//                         name="subject"
//                         value={formData.subject}
//                         onChange={handleChange}
//                       >
//                         <option value="" disabled>
//                           Select a subject
//                         </option>
//                         <option value="General Inquiry">General Inquiry</option>
//                         <option value="Support">Support</option>
//                         <option value="Feedback">Feedback</option>
//                         <option value="Other">Other</option>
//                       </select>
//                       {errors.subject && (
//                         <div className="invalid-feedback">{errors.subject}</div>
//                       )}
//                     </div>

//                     <div className="mb-4">
//                       <label htmlFor="description" className="form-label">
//                         Message <span className="text-danger">*</span>
//                       </label>
//                       <textarea
//                         className={`form-control form-control-lg ${
//                           errors.description ? "is-invalid" : ""
//                         }`}
//                         id="description"
//                         name="description"
//                         value={formData.description}
//                         onChange={handleChange}
//                         rows="5"
//                         placeholder="Your message here..."
//                       ></textarea>
//                       {errors.description && (
//                         <div className="invalid-feedback">
//                           {errors.description}
//                         </div>
//                       )}
//                     </div>

//                     <button
//                       type="submit"
//                       className="btn btn-primary w-100 py-2"
//                       disabled={loading}
//                     >
//                       {loading ? (
//                         <>
//                           <span
//                             className="spinner-border spinner-border-sm me-2"
//                             aria-hidden="true"
//                           ></span>
//                           Sending...
//                         </>
//                       ) : (
//                         <>
//                           <i className="fa fa-paper-plane me-2"></i> Send
//                           Message
//                         </>
//                       )}
//                     </button>
//                   </form>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactMe;

import React, { useState } from "react";
import axios from "axios";
import { formatPhoneNumber } from "../utils/formatPhoneNumber";
import { CONTACT_BASE_URL } from "../services/contactService";
import "./ContactStyle.css";

const ContactMe = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    subject: "",
    email: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  //hide email
  const [showFullEmail, setShowFullEmail] = useState(false);
  const fullEmail = "osman.techy@gmail.com";
  const maskedEmail = "(osman)***@gmail.com";

  const handleClick = () => {
    setShowFullEmail(!showFullEmail);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setIsSubmitted(false);

    // Validate required fields
    const { firstName, lastName, email, description } = formData;
    const newErrors = {};

    if (!firstName) newErrors.firstName = "First name is required.";
    if (!lastName) newErrors.lastName = "Last name is required.";
    if (!email) newErrors.email = "Email address is required.";
    if (!description) newErrors.description = "Message body is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors({
        message: "Please fill in all required fields!",
        ...newErrors,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${CONTACT_BASE_URL}/api/contacts/create`,
        formData
      );
      if (response.status === 200 || response.status === 201) {
        setIsSubmitted(true);
        setFormData({
          firstName: "",
          lastName: "",
          phone: "",
          subject: "",
          email: "",
          description: "",
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      if (error.response) {
        const { message, errors: backendErrors } = error.response.data;
        if (backendErrors && Array.isArray(backendErrors)) {
          const formattedErrors = backendErrors.reduce((acc, err) => {
            acc[err.param] = err.msg;
            return acc;
          }, {});
          setErrors({
            message: message || "Validation errors occurred",
            ...formattedErrors,
          });
        } else if (message) {
          setErrors({ message });
        }
      } else if (error.request) {
        setErrors({
          message: "No response from server. Please try again later.",
        });
      } else {
        setErrors({
          message: "An unexpected error occurred. Please try again.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero bg-primary text-white py-5 py-lg-6">
        <div className="container">
          <div className="row align-items-center">
            {/* <div className="col-lg-6 mb-4 mb-lg-0"> */}
            <div className="col mb-lg-0">
              <h1 className="display-4 fw-bold mb-3">Let's Connect</h1>
              <p className="lead mb-4">
                I'd love to hear about your project or answer any questions you
                might have. Reach out and let's start a conversation.
              </p>
              <div className="d-flex flex-wrap gap-3">
                <a
                  href="#contact-form"
                  className="btn btn-light btn-lg px-4 py-2"
                >
                  <i className="fa fa-paper-plane me-2"></i> Send a Message
                </a>
                <a
                  href="mailto:osman.techy@gmail.com"
                  className="btn btn-outline-light btn-lg px-4 py-2"
                >
                  <i className="fa fa-envelope me-2"></i> Email Me
                </a>
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="contact-illustration text-center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3059/3059518.png"
                  alt="Contact illustration"
                  className="img-fluid"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="py-5 py-lg-6">
        <div className="container my-5">
          <div className="row g-4">
            {/* Contact Info Section */}
            <div className="col-lg-5">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4 p-md-5 bg-primary text-white rounded-start">
                  <h1 className="card-title mb-4 text-white">Get in Touch</h1>
                  <p className="card-text mb-4">
                    Have a project in mind or want to discuss potential
                    opportunities? Fill out the form and I'll get back to you as
                    soon as possible.
                  </p>

                  <div className="mb-4">
                    <div className="d-flex align-items-center mb-3">
                      <i className="fa fa-envelope fa-lg me-3"></i>
                      <a
                        href="mailto:osman.techy@gmail.com"
                        onClick={handleClick}
                        className="text-white"
                      >
                        {showFullEmail ? fullEmail : maskedEmail}
                      </a>
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-3">Connect with me</h5>
                    <div className="d-flex gap-3">
                      <a
                        href="https://www.facebook.com/moudeyahmad"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa fa-facebook-f fa-lg"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/in/mahmoudaosman/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa fa-linkedin-in fa-lg"></i>
                      </a>
                      <a
                        href="https://github.com/mahmoudahmadosman"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa fa-github fa-lg"></i>
                      </a>
                      <a
                        href="https://twitter.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa fa-twitter fa-lg"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="col-lg-7">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4 p-md-5">
                  {isSubmitted ? (
                    <div className="text-center py-4">
                      <div className="mb-4">
                        <div className="d-inline-flex bg-success bg-opacity-10 p-4 rounded-circle">
                          <i className="fa fa-check-circle text-success fa-4x"></i>
                        </div>
                      </div>
                      <h3 className="mb-3">Thank You!</h3>
                      <p className="mb-4">
                        Your message has been sent successfully. I'll get back
                        to you soon.
                      </p>
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setIsSubmitted(false)}
                      >
                        Send Another Message
                      </button>
                    </div>
                  ) : (
                    <>
                      <h2 className="mb-4">Send a Message</h2>
                      {errors.message && (
                        <div className="alert alert-danger d-flex align-items-center mb-4">
                          <i className="fa fa-exclamation-circle me-2"></i>
                          <div>{errors.message}</div>
                        </div>
                      )}

                      <form onSubmit={handleSubmit}>
                        <div className="row g-3 mb-3">
                          <div className="col-md-6">
                            <label htmlFor="firstName" className="form-label">
                              <i className="fa fa-user me-2 text-primary"></i>
                              First Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control form-control-lg ${
                                errors.firstName ? "is-invalid" : ""
                              }`}
                              id="firstName"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleChange}
                              placeholder="First name"
                            />
                            {errors.firstName && (
                              <div className="invalid-feedback">
                                {errors.firstName}
                              </div>
                            )}
                          </div>

                          <div className="col-md-6">
                            <label htmlFor="lastName" className="form-label">
                              <i className="fa fa-user me-2 text-primary"></i>
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control form-control-lg ${
                                errors.lastName ? "is-invalid" : ""
                              }`}
                              id="lastName"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleChange}
                              placeholder="Last name"
                            />
                            {errors.lastName && (
                              <div className="invalid-feedback">
                                {errors.lastName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="mb-3">
                          <label htmlFor="email" className="form-label">
                            <i className="fa fa-envelope me-2 text-primary"></i>
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control form-control-lg ${
                              errors.email ? "is-invalid" : ""
                            }`}
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="your.email@gmail.com"
                          />
                          {errors.email && (
                            <div className="invalid-feedback">
                              {errors.email}
                            </div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="phone" className="form-label">
                            <i className="fa fa-phone me-2 text-primary"></i>
                            Phone Number
                          </label>
                          <input
                            type="tel"
                            className={`form-control form-control-lg ${
                              errors.phone ? "is-invalid" : ""
                            }`}
                            id="phone"
                            name="phone"
                            value={formatPhoneNumber(formData.phone)}
                            onChange={handleChange}
                            placeholder="(123) 456-7890"
                            maxLength={14}
                          />
                          {errors.phone && (
                            <div className="invalid-feedback">
                              {errors.phone}
                            </div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="subject" className="form-label">
                            <i className="fa fa-tag form-icon me-2"></i>Subject
                          </label>
                          <select
                            className={`form-select form-control-lg ${
                              errors.subject ? "is-invalid" : ""
                            }`}
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select a subject
                            </option>
                            <option value="General Inquiry">
                              General Inquiry
                            </option>
                            <option value="Support">Support</option>
                            <option value="Feedback">Feedback</option>
                            <option value="Other">Other</option>
                          </select>
                          {errors.subject && (
                            <div className="invalid-feedback">
                              {errors.subject}
                            </div>
                          )}
                        </div>

                        <div className="mb-4">
                          <label htmlFor="description" className="form-label">
                            Message <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className={`form-control form-control-lg ${
                              errors.description ? "is-invalid" : ""
                            }`}
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="5"
                            placeholder="Your message here..."
                          ></textarea>
                          {errors.description && (
                            <div className="invalid-feedback">
                              {errors.description}
                            </div>
                          )}
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary w-100 py-2"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                aria-hidden="true"
                              ></span>
                              Sending...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-paper-plane me-2"></i> Send
                              Message
                            </>
                          )}
                        </button>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactMe;
